import { useNavigate, useParams } from 'react-router'
import React, { useEffect, useMemo, useState } from 'react'
import ClinicHeader from 'src/clinic/components/ClinicHeader'
import { HeaderGreeting } from 'src/clinic/components/ClinicHeader/ClinicHeaderStyles'
import { getCPData, getCPDataWithParams } from 'src/clinic/services'
import { getSPDataWithParams } from 'src/supportPortal/services/services'
import { GenericHeaderBackButton } from 'src/consumer/components/ActivityPlansPage/MyPlanComponents'
import {
  getDataMapFromCommonResponse,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'
import { HomePageItem } from 'src/clinic/components/ClinicHomePage/ClinicHomepageStyles'
import { Dialog, ToggleButton, ToggleButtonGroup } from '@mui/material'
import ClinicAppointmentTypeForm from './components/ClinicAppointmentTypeForm'
import GridView from '@mui/icons-material/GridView'
import TableRows from '@mui/icons-material/TableRows'
import AppointmentListingTable from './components/AppointmentListingTable'
import { buildClinicEventsBasedOnTheDefaultTemplates } from './components/util'
import { filterClinicServicesByAvailableSpecialties } from 'src/consumer/helpers/screeningSpecialtyUtils'

const TEMPLATE_TYPES = {
  consultation: {
    id: 'consultation',
    title: 'Consultations',
  },
  'therapy-session': {
    id: 'therapy-session',
    title: 'Therapy',
  },
  'therapy-packages': {
    id: 'therapy-packages',
    title: 'Therapy Package',
  },
  assessments: {
    id: 'therapy-packages',
    title: 'Therapy Package',
  },
}

const TEMPLATE_TYPES_ARRAY = [
  TEMPLATE_TYPES.consultation,
  TEMPLATE_TYPES['therapy-session'],
  TEMPLATE_TYPES['therapy-packages'],
  TEMPLATE_TYPES.assessments,
]

const VIEW_TYPES = {
  listing: { id: 'listing', title: 'Listing' },
  grid: { id: 'grid', title: 'Grid' },
}

export default function ClinicAppointmentTypes() {
  const { clinicBrandId, clinicId } = useParams()

  return (
    <>
      {' '}
      <ClinicHeader
        component={
          <div>
            <div className="d-flex gap-2 justify-content-center align-items-center">
              <GenericHeaderBackButton
                clickfunction={() => window.history.back()}
                styles={{ margin: '20px' }}
              />
              <HeaderGreeting main>Clinic Services</HeaderGreeting>
            </div>
          </div>
        }
      />
      <ClinicAppointmentTypesListing clinicBrandId={clinicBrandId} clinicId={clinicId} />
    </>
  )
}

export function ClinicAppointmentTypesListing({
  clinicBrandId,
  clinicId,
  clinicLocation,
  clinicBrand,
  getServicesApiSignature = '/api/secure/clinic-appointment/list',
  getDefaultServicesApiSignature = '/api/secure/clinic-appointment/default-templates/list',
  getParamsForClinicServices = (params) => ({
    'clinic-location-id': params?.['clinic-location-id'],
    'clinic-brand-id': params?.['clinic-brand-id'],
    page: 1,
    'page-size': 500,
  }),
  saveAppointmentApiSignature,
}) {
  const [defaultTemplates, setDefaultTemplates] = useState()
  const [clinicAppointmentTypes, setClinicAppointmentTypes] = useState()
  const [loading, setLoading] = useState(false)
  const [viewType, setViewType] = useState(VIEW_TYPES.listing.id)

  const filteredDefaultTemplates = useMemo(() => {
    return filterClinicServicesByAvailableSpecialties(defaultTemplates, clinicLocation, clinicBrand)
  }, [defaultTemplates, clinicLocation, clinicBrand])

  const filteredClinicAppointmentTypes = useMemo(() => {
    return filterClinicServicesByAvailableSpecialties(
      clinicAppointmentTypes,
      clinicLocation,
      clinicBrand,
    )
  }, [clinicAppointmentTypes, clinicLocation, clinicBrand])

  const deafultClinicApptEvtTypes = useMemo(() => {
    return buildClinicEventsBasedOnTheDefaultTemplates(
      filteredDefaultTemplates,
      filteredClinicAppointmentTypes,
    )
  }, [filteredClinicAppointmentTypes, filteredDefaultTemplates])

  const nonDefaultClinicApptEvtTypes = useMemo(() => {
    return filteredClinicAppointmentTypes?.filter((apptType) => !apptType?.templateId)
  }, [filteredClinicAppointmentTypes])

  async function getDefaultClinicServicesTemplates() {
    // Use support portal API if the signature contains '/api/secure/cc/support/'
    const isSupportPortalAPI = getDefaultServicesApiSignature?.includes('/api/secure/cc/support/')
    const resp = isSupportPortalAPI
      ? await getSPDataWithParams(getDefaultServicesApiSignature, {}, undefined, undefined, true)
      : await getCPData(getDefaultServicesApiSignature)
    if (!!resp) {
      if (isCommonResponseSuccessfulV2(resp)) {
        const data = getDataMapFromCommonResponse(resp)

        setDefaultTemplates(data.defaultTemplates)
      }
    }
  }

  async function getClinicServicesForThisClinicLocation() {
    // Use support portal API if the signature contains '/api/secure/cc/support/'
    const isSupportPortalAPI = getServicesApiSignature?.includes('/api/secure/cc/support/')
    // Map clinicId/clinicBrandId to the expected parameter names
    const params = getParamsForClinicServices({
      'clinic-location-id': clinicId,
      'clinic-brand-id': clinicBrandId,
    })
    const resp = isSupportPortalAPI
      ? await getSPDataWithParams(getServicesApiSignature, params, undefined, undefined, true)
      : await getCPDataWithParams(getServicesApiSignature, params)
    if (resp?.status === 200) {
      if (isCommonResponseSuccessfulV2(resp)) {
        const data = getDataMapFromCommonResponse(resp)
        setClinicAppointmentTypes(data.appointmentTypes)
      }
    }
  }

  async function Setup() {
    setLoading(true)
    await Promise.all([
      getDefaultClinicServicesTemplates(),
      getClinicServicesForThisClinicLocation(),
    ])
    setLoading(false)
  }

  const handleViewType = (event, vType) => {
    if (vType !== null) {
      setViewType(vType)
    }
  }

  useEffect(() => {
    Setup()
  }, [])

  return (
    <>
      <div className="d-flex align-items-center justify-content-center">
        {/* setViewType */}
        {/* <ToggleButtonGroup
          value={viewType}
          exclusive
          onChange={handleViewType}
          sx={{ marginTop: '8px' }}
        >
          <ToggleButton value={VIEW_TYPES.listing.id}>
            <TableRows />
          </ToggleButton>
          <ToggleButton value={VIEW_TYPES.grid.id}>
            <GridView />
          </ToggleButton>
        </ToggleButtonGroup> */}
      </div>
      {viewType === VIEW_TYPES.grid.id && (
        <div
          style={{ maxWidth: '1200px', margin: '0 auto', padding: '10px' }}
          className="w-100 d-flex flex-column justify-content-start gap-4 flex-wrap py-2 flex-grow-1"
        >
          {TEMPLATE_TYPES_ARRAY?.map((templateType) => {
            return (
              <diV key={templateType?.id}>
                <ServciesBoxes
                  defaultServiceTemplates={filteredDefaultTemplates}
                  serviceType={templateType?.id}
                  serviceTypeTitle={templateType?.title}
                  allClinicServices={filteredClinicAppointmentTypes}
                  refreshData={getClinicServicesForThisClinicLocation}
                  clinicLocation={clinicLocation}
                  clinicBrand={clinicBrand}
                />
              </diV>
            )
          })}
        </div>
      )}
      {viewType === VIEW_TYPES.listing.id && (
        <div
          style={{ maxWidth: '1200px', margin: '0 auto', padding: '10px', height: '100%' }}
          className="w-100"
        >
          <AppointmentListingTable
            clinicApptTypes={[
              ...(deafultClinicApptEvtTypes || []),
              ...(nonDefaultClinicApptEvtTypes || []),
            ]}
            defaultTemplates={filteredDefaultTemplates}
            clinicLocation={clinicLocation}
            clinicBrand={clinicBrand}
            loadingPageData={loading}
            refreshData={getClinicServicesForThisClinicLocation}
            clinicId={clinicId}
            clinicBrandId={clinicBrandId}
            saveAppointmentApiSignature={saveAppointmentApiSignature}
          />
        </div>
      )}
    </>
  )
}

function ServciesBoxes({
  serviceType,
  defaultServiceTemplates,
  allClinicServices,
  serviceTypeTitle,
  refreshData,
  clinicLocation,
  clinicBrand,
}) {
  const templatesToRender = defaultServiceTemplates?.filter((temp) => temp?.type === serviceType)

  return (
    <>
      <h4 className="mb-3 mt-2">{serviceTypeTitle}</h4>
      <div className="d-flex align-items-center gap-3 flex-wrap">
        {templatesToRender?.map((template) => (
          <ClinicServiceTemplateBox
            key={template?.id}
            template={template}
            allClinicServices={allClinicServices}
            refreshData={refreshData}
            clinicLocation={clinicLocation}
            clinicBrand={clinicBrand}
          />
        ))}
        <ClinicServiceTemplateBox
          allClinicServices={allClinicServices}
          isAddNew
          refreshData={refreshData}
          clinicLocation={clinicLocation}
          clinicBrand={clinicBrand}
        />
        {/* <HomePageItem style={{ background: '#000000f2' }}>
          <div className="w-100 h-100 position-absolute d-flex flex-column justify-content-center align-items-center gap-2">
            <h4 className="mb-0" style={{ textDecoration: 'underline' }}>
              Add New
            </h4>
          </div>
        </HomePageItem> */}
      </div>
    </>
  )
}

function ClinicServiceTemplateBox({
  template,
  allClinicServices,
  isAddNew,
  refreshData,
  clinicLocation,
  clinicBrand,
}) {
  const [showForm, setShowForm] = useState(false)

  const currentMappedService = allClinicServices?.find((service) => {
    return service?.templateId === template?.id
  })

  function closeDialog() {
    setShowForm(false)
  }

  return (
    <>
      {isAddNew ? (
        <HomePageItem
          onClick={() => {
            setShowForm(true)
          }}
          style={{ background: '#000000f2' }}
        >
          <div className="w-100 h-100 position-absolute d-flex flex-column justify-content-center align-items-center gap-2">
            <h4 className="mb-0" style={{ textDecoration: 'underline' }}>
              Add New
            </h4>
          </div>
        </HomePageItem>
      ) : (
        <HomePageItem
          onClick={() => {
            setShowForm(true)
          }}
        >
          <div className="w-100 h-100 position-absolute d-flex flex-column justify-content-center align-items-center gap-2">
            <h4 className="mb-0">{template?.title}</h4>
            {!!currentMappedService ? (
              <span>Edit</span>
            ) : (
              <span className="text-warning">Not Set</span>
            )}
          </div>
        </HomePageItem>
      )}
      <Dialog open={showForm} onClose={closeDialog}>
        <ClinicAppointmentTypeForm
          clinicAppointmentType={isAddNew ? null : currentMappedService}
          closeDialog={closeDialog}
          refreshData={refreshData}
          clinicLocation={clinicLocation}
          clinicBrand={clinicBrand}
        />
      </Dialog>
    </>
  )
}
